module.exports = __webpack_public_path__ + "static/media/about_window.094daa65.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fastSearch/about_window.png
// module id = 803
// module chunks = 0